import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import { TransactionDetailProps } from "./TransactionDetailProps";
import { formatDate, formatTime } from "../../history.utils";
import useWindowDimensions, { CurrentScreen } from "../../../../../hooks/use-window-dimensions";
import styles from "../customer-transaction-history-detail.module.scss";
import { TransactionReceiptHeader } from "./TransactionReceiptHeader";
import { CopyIcon } from "../../../../../assets/icons";
import { handleCopy, getTransactionStatusInfo, formatCurrency } from "../../../../../utils";

export const PayAsYouGoTransactionDetail = ({
  transaction,
  onDownloadReceipt,
  isDownloading,
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const currentScreen: CurrentScreen = useWindowDimensions();
  const payAsYouGo = transaction.payAsYouGoDetails;
  const { label: statusLabel } = getTransactionStatusInfo(transaction.status);

  return (
    <>
       {/* <TransactionReceiptHeader
             status={transaction.status}
             amount={transaction.amount?.amount ?? 0}
             currency={transaction.amount?.currency}
             createdAt={transaction.createdAt }
           /> */}

      <div className={styles.detailsCard}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.billPeriod")}</span>
          <span className={styles.detailValue}>{t("history.web.dateBill", { date: formatDate(transaction.createdAt) })}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.status")}</span>
          <span className={styles.detailValue}>{statusLabel}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.amountPaid")}</span>
          <span className={styles.detailValue}>{formatCurrency(transaction.amount.amount, {currency: transaction.amount?.currency})}</span>
        </div>
       
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.date")}</span>
          <span className={styles.detailValue}>{formatDate(transaction.createdAt)}, {formatTime(transaction.createdAt).toLocaleLowerCase()}</span>
        </div>
      </div>

     <div className={styles.footer}>
        <div className={styles.detailRow}>
          <span className={styles.receiptLabel}>{t("history.transactionIdLabel")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.receiptValue}>{transaction.reference || t("history.web.notApplicable")}</span>
            {transaction.reference && (
              <CopyIcon onClick={() => handleCopy(transaction.reference)} className={styles.copyBtn} />
            )}
          </div>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.receiptLabel}>{t("history.web.requestId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.receiptValue}>{transaction.externalReference || t("history.web.notApplicable")}</span>
            {transaction.externalReference && (
              <CopyIcon onClick={() => handleCopy(transaction.externalReference)} className={styles.copyBtn} />
            )}
          </div>
        </div>
        </div>
    </>
  );
};
